// eslint-disable-next-line
// @ts-nocheck
import { bind } from 'hyperhtml';
import { Dialog, SvgManager } from 'core';
import getResourceManager from './getResourceManager';

const images = {
	error: '../images/Error.svg'
};

SvgManager.enqueue(Object.values(images));

const disabledCookies = () => {
	const resourceManager = getResourceManager('core');
	const title = resourceManager.getString(
		'system_requirements.failed_initialize_innovator'
	);
	const dialog = new Dialog('html', { title });

	dialog.dialogNode.classList.add(
		'aras-dialog-alert',
		'aras-dialog_disabled-cookies'
	);

	const message = resourceManager.getString(
		'login.cookies_are_disabled_msg_html'
	);
	bind(dialog.contentNode)`
		<div class="aras-dialog-alert__container">
			<aras-image src="${images.error}" class="aras-dialog-alert__img" />
			<span class="aras-dialog-alert__text">${message}</span>
		</div>
	`;

	dialog.dialogNode.addEventListener('cancel', (event) => {
		event.preventDefault();
	});

	dialog.show();

	return dialog.promise;
};

export default disabledCookies;
